import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rqfbj75yg: FaireProductEntity = {
  token: "p_7rqfbj75yg",
  type: "product",
  name: "( R327 )  VINTAGE ART STATEMENT NECKLACE",
  brandToken: "b_r5aqp735w9",
  brandName: "Jewelry Max",
  imageUrl:
    "https://cdn.faire.com/fastly/fa1df327c45df940eba00da2465b3487b1d002cf7a30d3737954d3de6468142c.jpeg",
  galleryImageUrls: [],
  priceDollars: 19.96,
  description: "VINTAGE ART STATEMENT NECKLACE  - LENGTH 18 INCHES  EXTEND",
  tags: [],
  msrpDollars: 39.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:50.920Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
